import {useMemo, useState} from 'react'
import {KTCard, KTIcon} from '../../../../_metronic/helpers'
import {INotification} from '../_model'
import {searchItems} from '../../../utils/helperFunction/_helper'
import notificaitonsListColumn from '../helper/notificationsListColumn'
import NotificationFilter from './NotificationFilter'

import {useRittApp} from '../../../utils/contextProvider/RittAppProvider'
import TableContent from '../../../utils/components/table-content/TableContent'
import {ListViewContext, ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import {BASE_URL} from '../../config'
import {showInfoToast} from '../../../utils/helperFunction/toast'
import toast from 'react-hot-toast'
import SelectNotification from './SelectNotification'
import InputSearchBox from '../../../utils/components/form/InputSearchBox'

const READ_NOTIFICATION_URL = `${BASE_URL}/api/protect/readNotification`

const NotificationsContent = () => {
  const queryClient = useQueryClient()
  const {notification: data} = useRittApp()

  const [searchTerm, setSearchTerm] = useState('')

  const {mutateAsync: readNotification} = useMutation({
    mutationFn: async (ids: number[]) => {
      const response = await axios.put(READ_NOTIFICATION_URL, {ids})

      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries('notificationLit')
      toast.dismiss()
      toast.success('Read successfull')
    },
    onError: () => {
      toast.dismiss()
      toast.error('Something went wrong')
    },
  })

  const filteredData = useMemo(() => {
    if (!data) return []
    const keys: (keyof INotification)[] = ['send_date', 'notify_text']

    const filteredData = searchItems(data, searchTerm, keys)
    return filteredData
  }, [data, searchTerm])

  const handleShow = (id: number) => {
    toast.loading('Processing..')
    readNotification([id])
  }

  const handleMarkAllAsRead = () => {
    const unread = filteredData.filter((note) => note.status === '0')
    const ids = unread.map((el) => el.id)
    if (ids.length <= 0) {
      toast.error('No unread notification')
    } else {
      readNotification(ids)
    }
  }

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center mt-10 mb-8'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div>
          <NotificationFilter />

          <button
            type='button'
            className='btn btn-transparent text-uppercase text-gray-800 fw-bolder'
            onClick={handleMarkAllAsRead}
          >
            Mark All As READ
          </button>
        </div>
      </div>

      <ListViewProvider data={filteredData} isLoading={!filteredData}>
        <SelectNotification context={ListViewContext} />
        {filteredData && (
          <TableContent
            isLoading={false}
            tableData={filteredData}
            tableColumn={notificaitonsListColumn(handleShow)}
            // className='align-baseline'
          />
        )}
      </ListViewProvider>

      <KTCard>
        {/* {isLoading ? (
          <div className='text-center my-8'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
         
        )} */}
      </KTCard>
    </div>
  )
}

export default NotificationsContent
